import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DamageDetailsRoutingModule } from './damage-details-routing.module';
import { SharedModule } from '../shared/shared.module';
import { DamagePhotosComponent } from './damage-photos/damage-photos.component';
import { DamageComponent } from './damage/damage.component';
import { DamageLocationComponent } from './damage-location/damage-location.component';
import { ExteriorDamageComponent } from './exterior-damage/exterior-damage.component';
import { ExteriorDamageCounterComponent } from './exterior-damage/exterior-damage-counter/exterior-damage-counter.component';
import { DamageConfirmationComponent } from './damage-confirmation/damage-confirmation.component';
import { RolloverComponent } from './rollover/rollover.component';
import { VehicleLocationComponent } from './vehicle-location/vehicle-location.component';
import { VehicleStorageFeeComponent } from './vehicle-storage-fee/vehicle-storage-fee.component';
import { DamagePhotosHelpfulTipsComponent } from './damage-photos-helpful-tips/damage-photos-helpful-tips.component'; // Ensure this path is correct and the component exists
import { DamagePhotosAddComponent } from './damage-photos-add/damage-photos-add.component';
import { DamagePhotosUploadComponent } from './damage-photos-upload/damage-photos-upload.component';

@NgModule({
  declarations: [
    DamageComponent,
    DamageLocationComponent,
    ExteriorDamageComponent,
    ExteriorDamageCounterComponent,
    DamageConfirmationComponent,
    DamagePhotosUploadComponent,
    DamagePhotosComponent,
    DamagePhotosHelpfulTipsComponent,
    DamagePhotosAddComponent,

    RolloverComponent,
    VehicleLocationComponent,
    VehicleStorageFeeComponent
  ],
  imports: [
    CommonModule,
    DamageDetailsRoutingModule,
    SharedModule,
  ],
  exports: [
    SharedModule,
  ]
})
export class DamageDetailsModule { }
